import styled, { css } from "styled-components";

export const ProviderImgWrapper = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	height: 87px;
	background: var(--casino-provider-gradient);
	margin: 20px 0;
	img {
		height: 90px;
		cursor: pointer;
	}

	${({ isSvgProviders }) =>
		isSvgProviders &&
		css`
			img {
				height: 40px;
			}
		`}

	.egtdigital {
		height: 35px;
	}

	.swiper-slide {
		display: flex;
		justify-content: center;
		align-items: center;
		min-width: 90px;
		height: 87px;
		width: auto;
	}

	.swiper {
		padding-right: 40px;
		.swiper-wrapper {
			margin-left: 20px;

			@media (min-width: 1600px) {
				margin-left: 0;
			}
		}
	}

	.swiper-button-prev,
	.swiper-button-next {
		display: flex;
	}

	.swiper-button-prev,
	.swiper-button-next {
		background: linear-gradient(180deg, rgba(25, 23, 38, 0.58) 0%, rgba(5, 5, 18, 0.58) 100%);
		backdrop-filter: blur(5px);
		height: 50px;
		top: 50%;
		width: 50px;
		color: var(--main-secondary-text-color);
		border-radius: 25px;
	}

	.swiper-button-prev {
		left: 0;
	}

	.swiper-button-next {
		right: 0;
	}

	.swiper-button-disabled {
		display: none;
	}

	.swiper-button-next:after,
	.swiper-button-prev:after {
		font-size: 22px;

		@media (min-width: 768px) {
			font-size: 32px;
		}

		@media (min-width: 1024px) {
			font-size: 35px;
		}
	}

	.swiper-button-prev:after {
		margin-right: 3px;
	}

	.swiper-button-next:after {
		margin-left: 3px;
	}

	@media (min-width: 1024px) {
		.swiper-button-prev,
		.swiper-button-next {
			display: none;
		}

		&:hover {
			.swiper-button-prev,
			.swiper-button-next {
				display: flex;
			}

			.swiper-button-prev,
			.swiper-button-next {
				background: linear-gradient(
					180deg,
					rgba(25, 23, 38, 0.58) 0%,
					rgba(5, 5, 18, 0.58) 100%
				);
				backdrop-filter: blur(5px);
				height: 100%;
				top: 22px;
				width: 30px;
				color: var(--main-secondary-text-color);
				border-radius: unset;

				@media (min-width: 768px) {
					width: 40px;
				}

				@media (min-width: 1024px) {
					width: 60px;
				}
			}

			.swiper-button-prev {
				left: 0;
			}

			.swiper-button-next {
				right: 0;
			}

			.swiper-button-disabled {
				display: none;
			}

			.swiper-button-next:after,
			.swiper-button-prev:after {
				font-size: 22px;

				@media (min-width: 768px) {
					font-size: 32px;
				}

				@media (min-width: 1024px) {
					font-size: 35px;
				}
			}

			.swiper-button-prev:after {
				margin-right: 3px;
			}

			.swiper-button-next:after {
				margin-left: 3px;
			}
		}
	}
`;

export const FooterProviderIconWrapper = styled.div`
	display: flex;
	justify-content: center;
	width: max-content;
	height: 45px;
	align-items: center;

	img {
		height: auto;
		max-width: 125px;
		min-width: 120px;
	}
`;
